import { articleSchuhe } from './articles-schuhe';
import { articleStreetwear } from './articles-streetwear';
import { articleSicherheit } from './articles-sicherheit';
import { articleGroessen } from './articles-groessen';
import { articleVersand } from './articles-versand';
import { articleLuxus } from './articles-luxus';
import { articleBudget } from './articles-budget';
import { articleQC } from './articles-qc';
import { articleTrends } from './articles-trends';

export const allAdditionalArticles = [
  articleSchuhe,
  articleStreetwear,
  articleSicherheit,
  articleGroessen,
  articleVersand,
  articleLuxus,
  articleBudget,
  articleQC,
  articleTrends,
];

export function getArticleBySlug(slug: string) {
  return allAdditionalArticles.find((a) => a.slug === slug) || null;
}

export function getAllArticleSlugs() {
  return allAdditionalArticles.map((a) => a.slug);
}